import {
  LogoAnsible,
  LogoCloudFormationColored,
  LogoKubernetesColored,
  LogoOpentofuColored,
  LogoPulumiColored,
  LogoTerraformColored,
  LogoTerragruntColored,
} from "components/icons/generated";

import { StackCreationVendor } from "../types";

export const vendorConfig = [
  {
    type: StackCreationVendor.Terraform,
    name: "OpenTofu / Terraform",
    logos: [LogoOpentofuColored, LogoTerraformColored],
  },
  {
    type: StackCreationVendor.Pulumi,
    name: "Pulumi",
    logos: [LogoPulumiColored],
  },
  {
    type: StackCreationVendor.CloudFormation,
    name: "CloudFormation",
    logos: [LogoCloudFormationColored],
  },
  {
    type: StackCreationVendor.Kubernetes,
    name: "Kubernetes",
    logos: [LogoKubernetesColored],
  },
  {
    type: StackCreationVendor.Terragrunt,
    name: "Terragrunt",
    logos: [LogoTerragruntColored],
  },
  {
    type: StackCreationVendor.Ansible,
    name: "Ansible",
    logos: [LogoAnsible],
  },
];
